import { getTranslationOrInnerText, isHTMLElement } from 'whisper-base';
import { NudgeTypes } from '../constants';
export const Definition = {
  // Internally the floating alerts are an Alert component. Once selected we need to further
  // validate that the parent is a floating alert container to track a render/dismiss event
  selector: '[data-alert-type][role="alert"]',
  shouldTrackRenderedForChild: ({
    parent
  }) => {
    // Only a floating alert when the parent has a test id of "pop-transition-wrapper"
    // otherwise this element is probably a regular alert component
    return parent.getAttribute('data-test-id') === 'pop-transition-wrapper';
  },
  shouldTrackDismissedForChild: ({
    parent
  }) => {
    // Only a floating alert when the parent has a test id of "pop-transition-wrapper"
    // otherwise this element is probably a regular alert component
    return parent.getAttribute('data-test-id') === 'pop-transition-wrapper';
  },
  getNudgeProperties: ({
    element
  }) => {
    // Get the title of the dialog
    const titleElement = element.querySelector('h2, h3, h4, h5, h6');
    const title = isHTMLElement(titleElement) ? getTranslationOrInnerText(titleElement) : 'no-title';
    const bodyElement = titleElement === null || titleElement === void 0 ? void 0 : titleElement.nextElementSibling;
    const text = isHTMLElement(bodyElement) ? getTranslationOrInnerText(bodyElement) : 'no-text';
    return {
      type: NudgeTypes.ALERT_FLOATING,
      title,
      text
    };
  }
};